import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="text-[#f5f5f2]" style={{ background: "#67665c" }} data-testid="site-footer">
      <div className="ob-container pt-24 pb-10">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/brand/main-logo.png"
                alt="Onboard Marketing"
                width="1247"
                height="126"
                className="h-6 md:h-7 w-auto object-contain"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </div>
            <p className="text-[18px] leading-[1.5] max-w-md opacity-80 font-light">
              A small team of creative, strategic people who genuinely enjoy helping New Zealand businesses grow.
            </p>
            <div className="mt-8 flex flex-col gap-2 text-[15px] opacity-80">
              <a href="mailto:aimee@onboard.nz" className="inline-flex items-center gap-2 hover:opacity-100" data-testid="footer-email">
                <Mail size={16} strokeWidth={1.5} /> aimee@onboard.nz
              </a>
              <a href="tel:+64210314301" className="inline-flex items-center gap-2 hover:opacity-100" data-testid="footer-phone">
                <Phone size={16} strokeWidth={1.5} /> +64 210 314 301
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="ob-eyebrow mb-5 opacity-80">Services</div>
            <ul className="space-y-2 text-[15px] opacity-85">
              {[
                ["Meta Advertising", "/services/meta-advertising"],
                ["Social Media Management", "/services/social-media-management"],
                ["Content Creation", "/services/content-creation"],
                ["Google Advertising", "/services/google-ads"],
                ["Website Design", "/services/website-design"],
                ["Branding & Design", "/services/branding"],
                ["Email Marketing", "/services/email-marketing"],
                ["SEO", "/services/seo"],
                ["Google Business Profile", "/services/google-business-profile"],
              ].map(([label, to]) => (
                <li key={to}><Link to={to} className="hover:opacity-100 opacity-80">{label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="ob-eyebrow mb-5 opacity-80">Company</div>
            <ul className="space-y-2 text-[15px] opacity-85">
              <li><Link to="/about" className="opacity-80 hover:opacity-100">About</Link></li>
              <li><Link to="/team" className="opacity-80 hover:opacity-100">Team</Link></li>
              <li><Link to="/case-studies" className="opacity-80 hover:opacity-100">Case Studies</Link></li>
              <li><Link to="/portfolio" className="opacity-80 hover:opacity-100">Portfolio</Link></li>
              <li><Link to="/resources" className="opacity-80 hover:opacity-100">Resources</Link></li>
              <li><Link to="/contact" className="opacity-80 hover:opacity-100">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="ob-eyebrow mb-5 opacity-80">Follow</div>
            <div className="flex gap-3">
              <a href="https://www.instagram.com/onboardmarketing.nz/" target="_blank" rel="noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full border border-white/25 inline-flex items-center justify-center hover:bg-white/10 transition-colors" data-testid="footer-instagram">
                <Instagram size={16} strokeWidth={1.5} />
              </a>
            </div>
            <div className="mt-8">
              <Link to="/contact" className="ob-btn" data-testid="footer-cta">Let's have a chat</Link>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row justify-between gap-4 text-[13px] opacity-60">
          <div>© {new Date().getFullYear()} Onboard Marketing. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:opacity-100">Privacy</Link>
            <Link to="/terms" className="hover:opacity-100">Terms</Link>
            <a href="https://onboard.nz" target="_blank" rel="noreferrer" className="hover:opacity-100">Visit Onboard Finance</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
